<template>
    <div class="dashboard-container">
        <Sidebar />
        <!-- ✅ Logos ocultos para el PDF (no visibles) -->
        <div style="display: none;">
            <img id="logo-asisa-pdf" src="/logo.png" alt="ASISA">
            <img id="logo-unit-pdf" src="/unit_seguros_logo.png" alt="Unit Seguros">
            <img id="firma-pdf" src="/firma.png" alt="ASISA">
            <img id="sello-pdf" src="/logo.png" alt="ASISA">
        </div>
        <!-- Main Content -->
        <main class="main-content">
            <header class="header-dashboard">
                <div>
                    <h1>Panel de Control</h1>
                    <p>Bienvenido de nuevo, {{ userEmail }}</p>
                </div>
                <div class="user-profile">
                    <div class="avatar-circle">{{ userInitials }}</div>
                    <div>
                        <p class="user-name">{{ userEmail }}</p>
                        <p class="user-role">Cliente</p>
                    </div>
                </div>
            </header>

            <!-- Stats Cards -->
            <section class="stats-grid" v-if="stats">
                <div class="stat-card">
                    <div class="stat-icon blue">
                        <ion-icon name="layers-outline"></ion-icon>
                    </div>
                    <div class="stat-info">
                        <h4>Total Pólizas</h4>
                        <span class="stat-value">{{ stats.total }}</span>
                    </div>
                </div>
                <div class="stat-card">
                    <div class="stat-icon green">
                        <ion-icon name="checkmark-circle-outline"></ion-icon>
                    </div>
                    <div class="stat-info">
                        <h4>Emitidas</h4>
                        <span class="stat-value">{{ stats.emitidas }}</span>
                    </div>
                </div>
                <div class="stat-card">
                    <div class="stat-icon orange">
                        <ion-icon name="time-outline"></ion-icon>
                    </div>
                    <div class="stat-info">
                        <h4>En Revisión</h4>
                        <span class="stat-value">{{ stats.revision }}</span>
                    </div>
                </div>
            </section>

            <!-- Table -->
            <section class="table-container">
                <div class="table-header">
                    <h3>Mis Pólizas</h3>
                    <!-- Botón Exportar Excel -->
                    <button class="btn-export" @click="exportarExcel" :disabled="exportando">
                        <ion-icon name="document-text-outline"></ion-icon> 
                        {{ exportando ? 'Exportando...' : 'Exportar Excel' }}
                    </button>
                    <button class="btn-filter" @click="abrirModalFiltros">
                        <ion-icon name="filter-outline"></ion-icon> Filtrar
                        <span v-if="filtrosActivos" class="filter-badge">●</span>
                    </button>
                </div>
                
                <!-- Loading state -->
                <div v-if="loading" class="loading-state">
                    <p>Cargando pólizas...</p>
                </div>
                
                <!-- Empty state -->
                <div v-else-if="polizasFiltradas.length === 0" class="empty-state">
                    <p>No hay pólizas que coincidan con los filtros.</p>
                    <button class="btn-clear" @click="limpiarFiltros">Limpiar filtros</button>
                </div>
                
                <table v-else class="polizas-table">
                    <thead>
                        <tr>
                            <th>Nº Póliza</th>
                            <th>Producto</th>
                            <th>Titular</th>
                            <th>Fecha</th>
                            <th>Estado</th>
                            <th>Wasap Renovación</th>
                            <th>Acción</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="poliza in polizas" :key="poliza.id">
                            <td><strong>{{ poliza.numero_poliza || 'Pendiente' }}</strong></td>
                            <td>{{ poliza.producto }}</td>
                            <td>{{ poliza.titular }}</td>
                            <td>{{ formatDate(poliza.fecha) }}</td>
                            <td>
                                <span :class="['status-badge', getStatusClass(poliza.estado)]">
                                    {{ getStatusText(poliza.estado) }}
                                </span>
                            </td>
                            <td>
                                <a :href="`https://wa.me/${poliza.telefono.replace(' ','').replace('+','')}?text=Hola,%20solicito%20la%20carta%20de%20renovación%20para%20mi%20póliza%20%23AS-2026-001`" target="_blank" class="btn-table" style="background-color: #e6fcf5; color: #0c85d0; border-color: #63e6be;">
                                    <ion-icon name="logo-whatsapp" style="color: #25d366;"></ion-icon> Renovación
                                </a>
                            </td>
                            <td class="actions">
                                <div class="btn-group">
                                    <button @click="descargarCertificado(poliza.id)" class="btn-icon" title="Descargar certificado" :disabled="descargando">
                                        <ion-icon name="download-outline"></ion-icon>
                                    </button>
                                    <button @click="verCuestionario(poliza.id)" class="btn-icon" title="Ver cuestionario de salud">
                                        <ion-icon name="clipboard-outline"></ion-icon>
                                    </button>
                                    <button @click="toggleVto(poliza)" :class="['btn-icon', poliza.anulado ? 'active' : '']" :title="poliza.anulado ? 'Anulado vencimiento' : 'Anular vencimiento'">
                                        <ion-icon name="calendar-outline"></ion-icon>
                                        <span class="btn-text">{{ poliza.anulado ? 'Anulado vto' : 'Anulación vto' }}</span>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody> 
                </table>
            </section>
            <!-- Modal de filtros -->
                    <div v-if="mostrarModal" class="modal-overlay" @click.self="cerrarModalFiltros">
                        <div class="modal-content">
                            <!-- ✅ HEADER FIJO -->
                            <div class="modal-header">
                                <h3>Filtrar pólizas</h3>
                                <button class="modal-close" @click="cerrarModalFiltros">×</button>
                            </div>
                            
                            <!-- ✅ BODY SCROLLABLE -->
                            <div class="modal-body">
                                <div class="filter-group">
                                    <label>Producto</label>
                                    <select v-model="filtros.producto">
                                        <option value="">Todos</option>
                                        <option value="Salud Completa">Salud Completa</option>
                                        <option value="Salud Completa (Expat)">Salud Completa (Expat)</option>
                                        <option value="Dental Premium">Dental Premium</option>
                                        <option value="Dental Plus">Dental Plus</option>
                                    </select>
                                </div>
                                <div class="filter-group">
                                    <label>Estado</label>
                                    <select v-model="filtros.estado">
                                        <option value="">Todos</option>
                                        <option value="emitida">Emitida</option>
                                        <option value="revision">En Revisión</option>
                                    </select>
                                </div>
                                <div class="filter-group">
                                    <label>Fecha desde</label>
                                    <input type="date" v-model="filtros.fecha_desde">
                                </div>
                                <div class="filter-group">
                                    <label>Fecha hasta</label>
                                    <input type="date" v-model="filtros.fecha_hasta">
                                </div>
                                <div class="filter-group">
                                    <label>Nº Póliza</label>
                                    <input type="text" v-model="filtros.numero_poliza" placeholder="Ej: AS-2026-001">
                                </div>
                                <div class="filter-group">
                                    <label>Titular</label>
                                    <input type="text" v-model="filtros.titular" placeholder="Nombre del titular">
                                </div>
                                
                                <!-- Añadir más campos para que se pueda ver el scroll -->
                                <div class="filter-group">
                                    <label>Compañía</label>
                                    <select v-model="filtros.compania">
                                        <option value="">Todas</option>
                                        <option value="ASISA">ASISA</option>
                                        <option value="ASISA Health">ASISA Health</option>
                                    </select>
                                </div>
                                <div class="filter-group">
                                    <label>Tipo de cobertura</label>
                                    <select v-model="filtros.cobertura">
                                        <option value="">Todas</option>
                                        <option value="Completa">Completa</option>
                                        <option value="Básica">Básica</option>
                                    </select>
                                </div>
                            </div>
                            
                            <!-- ✅ FOOTER FIJO -->
                            <div class="modal-footer">
                                <button class="btn-clear" @click="limpiarFiltros">Limpiar filtros</button>
                                <button class="btn-apply" @click="aplicarFiltros">Aplicar filtros</button>
                            </div>
                        </div>
                    </div>
            <!-- Modal Cuestionario de Salud -->
            <div v-if="mostrarModalCuestionario" class="modal-overlay" @click.self="cerrarModalCuestionario">
                <div class="modal-content modal-lg">
                    <div class="modal-header">
                        <h3>Cuestionario de Salud</h3>
                        <button class="modal-close" @click="cerrarModalCuestionario">×</button>
                    </div>
                    <div class="modal-body" v-if="cargandoCuestionario">
                        <div class="loading-state">
                            <p>Cargando cuestionario...</p>
                        </div>
                    </div>
                    <div class="modal-body" v-else-if="cuestionarioSeleccionado">
                        <!-- Resumen de respuestas -->
                        <div class="cuestionario-resumen">
                            <div class="resumen-header">
                                <strong>Resumen de respuestas</strong>
                                <span class="badge" :class="cuestionarioSeleccionado.tieneProblemas ? 'badge-warning' : 'badge-success'">
                                    {{ cuestionarioSeleccionado.tieneProblemas ? '⚠️ Revisión necesaria' : '✅ Sin problemas' }}
                                </span>
                            </div>
                            
                            <!-- Datos básicos -->
                            <div class="cuestionario-datos">
                                <h4>Datos del asegurado</h4>
                                <div class="datos-grid">
                                    <div><strong>Nombre:</strong> {{ cuestionarioSeleccionado.nombre_completo || cuestionarioSeleccionado.nombre + ' ' + cuestionarioSeleccionado.apellidos }}</div>
                                    <div><strong>NIF/NIE:</strong> {{ cuestionarioSeleccionado.documento }}</div>
                                    <div><strong>Fecha Nacimiento:</strong> {{ cuestionarioSeleccionado.fecha_nacimiento }}</div>
                                    <div><strong>Peso:</strong> {{ cuestionarioSeleccionado.peso }} kg</div>
                                    <div><strong>Estatura:</strong> {{ cuestionarioSeleccionado.estatura }} cm</div>
                                    <div><strong>Sexo:</strong> {{ cuestionarioSeleccionado.sexo }}</div>
                                </div>
                            </div>
                            <!-- Preguntas y respuestas -->
                            <div class="cuestionario-preguntas">
                                <h4>Preguntas y respuestas</h4>
                                <div class="preguntas-lista">
                                    <div v-for="respuesta in cuestionarioSeleccionado.respuestas" 
                                        :key="respuesta.id" 
                                        :class="['pregunta-item', respuesta.value === 'si' ? 'respuesta-si' : 'respuesta-no']">
                                        <div class="pregunta-text">
                                            <span class="pregunta-num">{{ respuesta.id }}.</span>
                                            {{ respuesta.text }}
                                        </div>
                                        <div class="pregunta-respuesta">
                                            <span :class="['respuesta-badge', respuesta.value === 'si' ? 'badge-si' : 'badge-no']">
                                                {{ respuesta.value === 'si' ? 'SÍ' : 'NO' }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- Aclaraciones -->
                            <div class="cuestionario-aclaraciones" v-if="tieneAclaraciones(cuestionarioSeleccionado.aclaraciones)">
                                <h4>Aclaraciones</h4>
                                <div class="aclaraciones-content">
                                    <div v-for="(valor, key) in cuestionarioSeleccionado.aclaraciones" 
                                        :key="key" 
                                        v-if="valor" 
                                        class="aclaracion-item">
                                        <strong>{{ getPreguntaTexto(key) }}:</strong>
                                        <p>{{ valor }}</p>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- JSON raw (opcional, colapsable) -->
                            <div class="cuestionario-json">
                                <div class="json-header" @click="mostrarJson = !mostrarJson">
                                    <ion-icon :name="mostrarJson ? 'chevron-down-outline' : 'chevron-forward-outline'"></ion-icon>
                                    Ver JSON completo
                                </div>
                                <pre v-if="mostrarJson" class="json-content">{{ JSON.stringify(cuestionarioSeleccionado, null, 2) }}</pre>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn-clear" @click="cerrarModalCuestionario">Cerrar</button>
                        <button class="btn-apply" @click="descargarCuestionarioPDF">
                            <ion-icon name="download-outline"></ion-icon> Descargar PDF
                        </button>
                    </div>
                                    </div>
            </div>
        </main>
    </div>
</template>

<script>
import Sidebar from '@/components/layout/Sidebar.vue';
import { jsPDF } from 'jspdf'
import { API_URL } from '@/config'
import * as XLSX from 'xlsx'

export default {
    name: 'AreaPrivada',
    components: { Sidebar },
    computed: {
        currentLang() {
            return this.$route.params.lang || 'es'
        }
    },
    data() {
        return {
            loading: true,
            userEmail: '',
            userHash: '',
            stats: null,
            polizas: [],
            mostrarModal: false,
            filtros: {
                producto: '',
                estado: '',
                fecha_desde: '',
                fecha_hasta: '',
                numero_poliza: '',
                titular: ''
            },
            filtrosAplicados: {},
            descargando: false,
            exportando: false,
            mostrarModalCuestionario: false,
            cuestionarioSeleccionado: null,
            cargandoCuestionario: false,
            mostrarJson: false,
            polizaFiltroId: null
        }
    },
    beforeRouteLeave(to, from, next) {
        // Limpiar cuando salgamos del área privada
        sessionStorage.removeItem('area_privada_reloaded')
        next()
    },
    computed: {
        userInitials() {
            if (!this.userEmail) return 'U'
            return this.userEmail.substring(0, 2).toUpperCase()
        },
        filtrosActivos() {
            return Object.keys(this.filtrosAplicados).length > 0
        },
        polizasFiltradas() {
            let resultado = [...this.polizas]
            
            // Filtrar por producto
            if (this.filtrosAplicados.producto) {
                resultado = resultado.filter(p => 
                    p.producto && p.producto.includes(this.filtrosAplicados.producto)
                )
            }
            
            // Filtrar por estado
            if (this.filtrosAplicados.estado) {
                resultado = resultado.filter(p => 
                    this.getStatusClass(p.estado) === this.filtrosAplicados.estado ||
                    this.getStatusText(p.estado).toLowerCase() === this.filtrosAplicados.estado.toLowerCase()
                )
            }
            
            // Filtrar por fecha desde
            if (this.filtrosAplicados.fecha_desde) {
                const fechaDesde = new Date(this.filtrosAplicados.fecha_desde)
                resultado = resultado.filter(p => {
                    const fechaPoliza = new Date(p.fecha)
                    return fechaPoliza >= fechaDesde
                })
            }
            
            // Filtrar por fecha hasta
            if (this.filtrosAplicados.fecha_hasta) {
                const fechaHasta = new Date(this.filtrosAplicados.fecha_hasta)
                fechaHasta.setHours(23, 59, 59)
                resultado = resultado.filter(p => {
                    const fechaPoliza = new Date(p.fecha)
                    return fechaPoliza <= fechaHasta
                })
            }
            
            // Filtrar por número de póliza
            if (this.filtrosAplicados.numero_poliza) {
                const busqueda = this.filtrosAplicados.numero_poliza.toLowerCase()
                resultado = resultado.filter(p => 
                    p.numero_poliza && p.numero_poliza.toLowerCase().includes(busqueda)
                )
            }
            
            // Filtrar por titular
            if (this.filtrosAplicados.titular) {
                const busqueda = this.filtrosAplicados.titular.toLowerCase()
                resultado = resultado.filter(p => 
                    p.titular && p.titular.toLowerCase().includes(busqueda)
                )
            }
            
            return resultado
        },
        polizasFiltradas() {
            let resultado = [...this.polizas]
            
            // Si viene filtrado por póliza específica desde vencimientos
            if (this.polizaFiltroId) {
                resultado = resultado.filter(p => p.id === this.polizaFiltroId)
                
                // Limpiar el filtro después de usarlo (para que no persista)
                if (this.$route.query.poliza) {
                    this.$router.replace({ query: {} })
                }
            }
            
            // ... resto de filtros (producto, estado, fechas) ...
            
            return resultado
        }
    },
    mounted() {
        // Verificar si ya se ha hecho reload en esta sesión
        const alreadyReloaded = sessionStorage.getItem('area_privada_reloaded')
        
        if (!alreadyReloaded) {
            sessionStorage.setItem('area_privada_reloaded', 'true')
            setTimeout(() => {
                window.location.reload()
            }, 100)
        } else {
            this.verificarSesion()
        }

        // Verificar si viene del calendario con póliza específica
        const polizaId = this.$route.query.poliza
        const desde = this.$route.query.desde
        
        if (polizaId && desde === 'vencimientos') {
            // Guardar para filtrar después de cargar
            this.polizaFiltroId = parseInt(polizaId)
            
            // Mostrar mensaje
            setTimeout(() => {
                const poliza = this.polizas.find(p => p.id === this.polizaFiltroId)
                if (poliza) {
                    alert(`Mostrando detalles de la póliza ${poliza.numero_poliza}`)
                }
            }, 500)
        }
    },
    methods: {
        async toggleVto(poliza) {
            const nuevoEstado = !poliza.anulado;
            
            // Mostrar confirmación si se va a anular
            if (nuevoEstado) {
                if (!confirm('⚠️ Al anular el vencimiento, se enviará un email de recordatorio al cliente 45 días antes de la fecha de vencimiento.\n\n¿Estás seguro de continuar?')) {
                    return;
                }
            }
            
            try {
                // Primero actualizar el estado en el backend
                const response = await fetch(`${API_URL}/com.api.update-anulacion.php`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${process.env.VUE_APP_TOKEN}`
                    },
                    body: JSON.stringify({
                        hash: localStorage.getItem('expat_visa_session'),
                        poliza_id: poliza.id,
                        anulado: nuevoEstado ? "1" : "0"
                    })
                })
                
                const data = await response.json()
                
                if (data.success) {
                    // Si se anula, programar el email de vencimiento
                    if (nuevoEstado) {
                        await this.programarEmailVencimiento(poliza.id)
                    }
                    
                    // Actualizar estado local
                    poliza.anulado = nuevoEstado;
                    alert(data.message || (nuevoEstado ? '✅ Vencimiento anulado. Se enviará email de recordatorio 45 días antes.' : '✅ Anulación de vencimiento cancelada'))
                } else {
                    alert(data.message || 'Error al actualizar')
                }
            } catch (error) {
                console.error('Error:', error)
                alert('Error al procesar la solicitud')
            }
        },
        async programarEmailVencimiento(polizaId) {
            try {
                const response = await fetch(`${API_URL}/com.api.schedule-vencimiento.php`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${process.env.VUE_APP_TOKEN}`
                    },
                    body: JSON.stringify({
                        poliza_id: polizaId,
                        hash: localStorage.getItem('expat_visa_session'),
                        anulado: "1"
                    })
                })
                
                const data = await response.json()
                
                if (data.success) {
                    console.log('✅ Email programado:', data.message)
                } else {
                    console.error('Error programando email:', data.error)
                }
            } catch (error) {
                console.error('Error:', error)
            }
        },
        verificarSesion() {
            const hash = localStorage.getItem('expat_visa_session')
            const user = localStorage.getItem('user')
            
            if (!hash || !user) {
                this.$router.push({ name: 'login' })
                return
            }
            
            this.userEmail = user
            this.userHash = hash
            this.cargarPolizas()
        },
        async cargarPolizas() {
            this.loading = true
            try {
                const response = await fetch(`${API_URL}/com.api.get-polizas.php`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${process.env.VUE_APP_TOKEN}`
                    },
                    body: JSON.stringify({ hash: this.userHash })
                })
                
                const data = await response.json()
                console.log('Datos recibidos:', data)
                
                if (data.success) {
                    this.stats = data.stats
                    this.polizas = data.polizas.map(p => ({
                        ...p,
                        // ✅ CORREGIDO: comparar con string "1"
                        anulado: p.anulado === "1" || p.anulado === 1 ? true : false
                    }))
                } else {
                    console.error('Error:', data.error)
                    alert(data.error)
                    setTimeout(() =>{
                         this.cerrarSesion()
                    }, 1000)
                }
            } catch (error) {
                console.error('Error de red:', error)
            } finally {
                this.loading = false
            }
        },
        
        formatDate(dateString) {
            if (!dateString) return '-'
            const date = new Date(dateString)
            return date.toLocaleDateString('es-ES')
        },
        
        getStatusClass(estado) {
            const classes = {
                'aprobado': 'emitida',
                'pagado': 'emitida',
                'pendiente_revision': 'revision',
                'revision': 'revision'
            }
            return classes[estado] || 'revision'
        },
        
        getStatusText(estado) {
            const texts = {
                'aprobado': 'Emitida',
                'pagado': 'Emitida y abonada',
                'pendiente_revision': 'En Revisión',
                'revision': 'En Revisión'
            }
            return texts[estado] || estado
        },
        
        cerrarSesion() {
            localStorage.removeItem('expat_visa_session')
            localStorage.removeItem('user')
            localStorage.removeItem('user_name')
            this.$router.push({ name: 'login' })
        },
                // ========== FILTROS ==========
        abrirModalFiltros() {
            // Copiar filtros actuales al modal
            this.filtros = { ...this.filtrosAplicados }
            this.mostrarModal = true
        },
        
        cerrarModalFiltros() {
            this.mostrarModal = false
        },
        
        aplicarFiltros() {
            // Guardar solo los filtros con valor
            this.filtrosAplicados = {}
            Object.keys(this.filtros).forEach(key => {
                if (this.filtros[key] && this.filtros[key] !== '') {
                    this.filtrosAplicados[key] = this.filtros[key]
                }
            })
            this.mostrarModal = false
        },
        limpiarFiltros() {
            this.filtros = {
                producto: '',
                estado: '',
                fecha_desde: '',
                fecha_hasta: '',
                numero_poliza: '',
                titular: ''
            }
            this.filtrosAplicados = {}
            this.mostrarModal = false
        },
        async descargarCertificado(polizaId) {
            try {
                // Mostrar indicador de carga
                this.descargando = true
                
                const response = await fetch(`${API_URL}/com.api.download-certificate.php`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${process.env.VUE_APP_TOKEN}`
                    },
                    body: JSON.stringify({
                        poliza_id: polizaId,
                        hash: this.userHash
                    })
                })
                
                const result = await response.json()
                
                if (!result.success) {
                    throw new Error(result.error || 'Error al obtener datos')
                }
                
                // Generar PDF con los datos
                this.generarPDF(result.data)
                
            } catch (error) {
                console.error('Error:', error)
                alert('Error al generar el certificado: ' + error.message)
            } finally {
                this.descargando = false
            }
        },
        generarPDF(data) {
            const doc = new jsPDF({
                orientation: 'portrait',
                unit: 'mm',
                format: 'a4',
                compress: true
            })
            const fullDate = new Date().toLocaleDateString('es-ES')
            
            // 🔹 Obtener fechas y formatear como "Mes Año"
            const fechaInicioStr = data.fecha_inicio_poliza || data.fecha_contratacion || new Date().toLocaleDateString('es-ES')
            const [dia, mes, año] = fechaInicioStr.split('/').map(Number)
            const fechaInicio = new Date(año, mes - 1, dia)
            const fechaInicioValida = !isNaN(fechaInicio.getTime()) ? fechaInicio : new Date()
            
            const mes1 = fechaInicioValida.toLocaleDateString('es-ES', { month: 'long' })
            const año1 = fechaInicioValida.getFullYear()
            const fechaInicioDisplayOne = `1 de ${mes1} de ${año1}`
            
            const fechaVencimiento = new Date(fechaInicioValida)
            fechaVencimiento.setFullYear(fechaVencimiento.getFullYear() + 1)
            const mes2 = fechaVencimiento.toLocaleDateString('es-ES', { month: 'long' })
            const año2 = fechaVencimiento.getFullYear()
            const fechaFinDisplayOne = `1 de ${mes2} de ${año2}`

            // Obtener imágenes
            const asisaLogoImg = document.getElementById('logo-asisa-pdf')
            const firmaImg = document.getElementById('firma-pdf')
            const selloImg = document.getElementById('sello-pdf')
            
            // 🔹 OBTENER LA FIRMA DEL USUARIO
            let firmaUsuarioData = null
            if (data.firma_usuario) {
                firmaUsuarioData = data.firma_usuario
            }
            
            const getBase64Image = (img) => {
                if (!img || img.naturalWidth === 0) return null
                try {
                    const canvas = document.createElement("canvas")
                    canvas.width = img.naturalWidth
                    canvas.height = img.naturalHeight
                    const ctx = canvas.getContext("2d")
                    ctx.drawImage(img, 0, 0)
                    return canvas.toDataURL("image/png")
                } catch (e) {
                    console.error("Canvas conversion error:", e)
                    return null
                }
            }

            const asisaData = getBase64Image(asisaLogoImg)
            const firmaData = getBase64Image(firmaImg)
            const selloData = getBase64Image(selloImg)

            // ---- CABECERA ----
            if (asisaData) {
                doc.addImage(asisaData, 'PNG', 15, 10, 35, 12)
            } else {
                doc.setTextColor(28, 74, 141)
                doc.setFontSize(20)
                doc.setFont('helvetica', 'bold')
                doc.text('asisa', 15, 20)
            }

            // ---- TÍTULO ----
            doc.setTextColor(0, 0, 0)
            doc.setFontSize(14)
            doc.setFont('helvetica', 'bold')
            doc.text('CERTIFICA', 105, 30, { align: 'center' })
            
            doc.setDrawColor(28, 74, 141)
            doc.setLineWidth(0.8)
            doc.line(30, 34, 180, 34)

            // ---- CUERPO PRINCIPAL ----
            doc.setFontSize(10)
            doc.setFont('helvetica', 'normal')
            
            const certText1 = `Jaime Ortiz Olmeda, Director Comercial y Marketing, con NIF: 5.568.055-W, y con capacidad legal representativa en ASISA ASISTENCIA SANITARIA INTERPROVINCIAL DE SEGUROS, S.A.U., registrada en Madrid, Calle Juan Ignacio Luca de Tena, 12, y con C.I.F.: A-08169294`
            doc.text(certText1, 20, 45, { maxWidth: 170, align: 'justify' })

            doc.setFont('helvetica', 'bold')
            doc.text('CERTIFICA', 105, 60, { align: 'center' })
            doc.setFont('helvetica', 'normal')

            const certText2 = `${data.nombre} ${data.apellidos} con Nº de Pasaporte ${data.documento} y número de póliza ${data.numero_poliza} está registrado/a en ASISA, según convenio firmado, con una póliza de seguro de enfermedad (modalidad asistencia sanitaria, sin carencias y sin copagos) desde ${fechaInicioDisplayOne} hasta el ${fechaFinDisplayOne}, estando registrado a la fecha y pago vigente.`
            doc.text(certText2, 20, 75, { maxWidth: 170, align: 'justify' })

            const certText3 = `El seguro contratado, denominado ASISA Health RESIDENTS, corresponde a la modalidad de prestación de servicios a través de Cuadro Médico, sin copagos, y cobertura del 100% de los gastos médicos. No existe límite de gastos en sus diferentes coberturas, al no tratarse de un seguro de reembolso de gastos.`
            doc.text(certText3, 20, 100, { maxWidth: 170, align: 'justify' })

            const certText4 = `De acuerdo con lo previsto en las Condiciones Generales, en los términos y límites pactados, el seguro incluye las siguientes coberturas, de ámbito nacional.`
            doc.text(certText4, 20, 120, { maxWidth: 170, align: 'justify' })

            const coberturas = [
                '- Urgencias 24 horas',
                '- Atención Primaria (Medicina General, Pediatría y Enfermería)',
                '- Medicina Especializada, Medios de Diagnóstico y Cirugía Ambulatoria',
                '- Hospitalización por motivo médico, quirúrgico, psiquiátrico, pediátrico.',
                '- Técnicas Especiales de Tratamiento y Psicoterapia',
                '- Prótesis e Implantes, Trasplantes',
                '- Transporte sanitario (ambulancias).',
                '- Programas de Medicina Preventiva',
                '- Asistencia derivada de Accidentes Laborales y de Circulación',
                '- Garantía de Repatriación en caso de fallecimiento del asegurado',
                '- Cobertura de Gastos Médicos en el extranjero para el caso de urgencia'
            ]

            let yPos = 130
            const lineHeight = 6.0

            coberturas.forEach((item) => {
                doc.text(item, 25, yPos, { maxWidth: 160 })
                yPos += lineHeight
            })

            // ---- INFORMACIÓN DE FECHAS Y ESTADO ----
            const infoY = yPos + 8
            
            doc.setFontSize(10)
            doc.setFont('helvetica', 'bold')
            doc.text(`INICIO DE COBERTURA:`, 20, infoY)
            doc.setFont('helvetica', 'normal')
            doc.text(fechaInicioDisplayOne, 85, infoY)

            doc.setFont('helvetica', 'bold')
            doc.text(`FIN DE COBERTURA:`, 20, infoY + 8)
            doc.setFont('helvetica', 'normal')
            doc.text(fechaFinDisplayOne, 85, infoY + 8)

            doc.setFont('helvetica', 'bold')
            doc.text(`ESTADO DEL RECIBO:`, 20, infoY + 16)
            doc.setFont('helvetica', 'normal')
            doc.text(`Al corriente de pago según contrato, y sin deudas con ASISA`, 85, infoY + 16, { maxWidth: 100 })

            // ============================================================
            // 🔹 FIRMAS EN 2 COLUMNAS
            // ============================================================
            const firmaBaseY = infoY + 30

            // Línea separadora antes de firmas
            doc.setDrawColor(200, 200, 200)
            doc.setLineWidth(0.3)
            doc.line(20, firmaBaseY - 5, 190, firmaBaseY - 5)

            // Título de firmas
            doc.setFontSize(10)
            doc.setFont('helvetica', 'bold')
            doc.setTextColor(28, 74, 141)
            doc.text('FIRMAS', 105, firmaBaseY + 2, { align: 'center' })
            doc.setTextColor(0, 0, 0)
            
            // ---- COLUMNA IZQUIERDA: Firma del contratante ----
            const colX = 25
            const colY = firmaBaseY + 6
            const colWidth = 75
            
            // Título columna
            doc.setFontSize(8)
            doc.setFont('helvetica', 'italic')
            doc.setTextColor(100, 100, 100)
            doc.text('Firma del contratante', colX + (colWidth / 2), colY, { align: 'center' })
            doc.setTextColor(0, 0, 0)
            
            // Firma del usuario
            const firmaUsuarioY = colY + 6
            if (firmaUsuarioData) {
                try {
                    // Limpiar la firma si tiene prefijo
                    let firmaDataClean = firmaUsuarioData
                    if (firmaDataClean && firmaDataClean.startsWith('data:image')) {
                        // Ya está en el formato correcto
                    } else if (firmaDataClean && !firmaDataClean.startsWith('data:image')) {
                        firmaDataClean = 'data:image/png;base64,' + firmaDataClean
                    }
                    
                    doc.addImage(firmaDataClean, 'PNG', colX + 10, firmaUsuarioY, 55, 20)
                } catch (e) {
                    console.warn('No se pudo añadir la firma del usuario:', e)
                }
            }
            
            // Nombre del contratante debajo
            const nombreCompleto = `${data.nombre} ${data.apellidos}`.trim()
            doc.setFontSize(9)
            doc.setFont('helvetica', 'bold')
            doc.text(`Fdo: ${nombreCompleto}`, colX + (colWidth / 2), firmaUsuarioY + 28, { align: 'center' })
            doc.setFont('helvetica', 'normal')
            doc.setFontSize(8)
            doc.text('Contratante', colX + (colWidth / 2), firmaUsuarioY + 34, { align: 'center' })
            
            // ---- COLUMNA DERECHA: Firma del Director ----
            const colXDer = 105
            const colYDer = colY
            
            // Título columna
            doc.setFontSize(8)
            doc.setFont('helvetica', 'italic')
            doc.setTextColor(100, 100, 100)
            doc.text('Firma del Director', colXDer + (colWidth / 2), colYDer, { align: 'center' })
            doc.setTextColor(0, 0, 0)
            
            // Firma del director (imagen)
            const firmaDirectorY = colYDer + 6
            if (firmaData) {
                try {
                    doc.addImage(firmaData, 'PNG', colXDer + 10, firmaDirectorY, 55, 20)
                } catch (e) {
                    console.warn('No se pudo añadir la firma del director:', e)
                }
            }
            
            // Texto del director
            doc.setFontSize(9)
            doc.setFont('helvetica', 'bold')
            doc.text('Fdo: Jaime Ortiz Olmeda', colXDer + (colWidth / 2), firmaDirectorY + 28, { align: 'center' })
            doc.setFont('helvetica', 'normal')
            doc.setFontSize(8)
            doc.text('Director Comercial y Marketing', colXDer + (colWidth / 2), firmaDirectorY + 34, { align: 'center' })
            
            // ---- TEXTO "Y para que conste" CENTRADO DEBAJO ----
            const yTexto = Math.max(firmaUsuarioY + 40, firmaDirectorY + 40) + 10
            doc.setFontSize(10)
            doc.setFont('helvetica', 'normal')
            doc.setTextColor(0, 0, 0)
            doc.text(`Y para que conste, firmo la presente en Madrid, a ${fullDate}`, 105, yTexto, { align: 'center' })
            
            // ---- SELLO (centrado abajo) ----
            if (selloData) {
                try {
                    doc.addImage(selloData, 'PNG', 175, yTexto + 10, 16, 16)
                } catch (e) {
                    console.warn('No se pudo añadir el sello:', e)
                }
            }

            // ---- PIE DE PÁGINA ----
            doc.setFontSize(8)
            doc.setTextColor(150, 150, 150)
            doc.text(`Página 1 de 1`, 105, 285, { align: 'center' })
            doc.text(`Documento generado el ${fullDate}`, 105, 290, { align: 'center' })

            doc.save(`Certificado_${data.numero_poliza}.pdf`)
        },
        exportarExcel() {
            if (this.polizasFiltradas.length === 0) {
                alert('No hay datos para exportar')
                return
            }
            
            this.exportando = true
            
            try {
                // Preparar datos para Excel
                const datosExport = this.polizasFiltradas.map(p => ({
                    'Nº Póliza': p.numero_poliza || 'Pendiente',
                    'Producto': p.producto,
                    'Titular': p.titular,
                    'Fecha Contratación': this.formatDate(p.fecha),
                    'Estado': this.getStatusText(p.estado),
                    'Precio Mensual': `${p.precio_mensual} ${p.moneda || 'EUR'}`,
                    'Documento': p.documento || '-'
                }))
                
                // Crear hoja de cálculo
                const ws = XLSX.utils.json_to_sheet(datosExport)
                
                // Ajustar anchos de columnas (opcional)
                const colWidths = [
                    { wch: 15 }, // Nº Póliza
                    { wch: 25 }, // Producto
                    { wch: 25 }, // Titular
                    { wch: 15 }, // Fecha
                    { wch: 12 }, // Estado
                    { wch: 15 }, // Precio
                    { wch: 20 }  // Documento
                ]
                ws['!cols'] = colWidths
                
                // Crear libro y añadir hoja
                const wb = XLSX.utils.book_new()
                XLSX.utils.book_append_sheet(wb, ws, 'Mis Polizas')
                
                // Generar archivo y descargar
                const fecha = new Date().toISOString().split('T')[0]
                XLSX.writeFile(wb, `polizas_${fecha}.xlsx`)
                
            } catch (error) {
                console.error('Error exportando Excel:', error)
                alert('Error al generar el archivo Excel')
            } finally {
                this.exportando = false
            }
        },
        async verCuestionario(polizaId) {
            this.cargandoCuestionario = true
            this.mostrarModalCuestionario = true
            
            try {
                const response = await fetch(`${API_URL}/com.api.get-cuestionario.php`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${process.env.VUE_APP_TOKEN}`
                    },
                    body: JSON.stringify({
                        poliza_id: polizaId,
                        hash: this.userHash
                    })
                })
                
                const data = await response.json()
                
                if (data.success) {
                    this.cuestionarioSeleccionado = data.cuestionario
                    console.log("aaaaaa " + this.cuestionarioSeleccionado.nombre)
                } else {
                    throw new Error(data.error || 'Error al cargar el cuestionario')
                }
            } catch (error) {
                console.error('Error:', error)
                alert('Error al cargar el cuestionario: ' + error.message)
                this.mostrarModalCuestionario = false
            } finally {
                this.cargandoCuestionario = false
            }
        },
        calcularIMC(peso, estatura) {
            if (!peso || !estatura) return '-'
            const alturaMetros = estatura / 100
            const imc = peso / (alturaMetros * alturaMetros)
            return imc.toFixed(1)
        },

        tieneAclaraciones(aclaraciones) {
            return aclaraciones && Object.values(aclaraciones).some(v => v && v.trim() !== '')
        },

        getPreguntaTexto(key) {
            const textos = {
                q1: 'Ingreso en centro sanitario',
                q2: 'Intervención quirúrgica',
                q3: 'Proceso tumoral o cáncer',
                q4: 'Síntomas persistentes',
                q5: 'Enfermedades adicionales',
                q6: 'Medicación',
                q7: 'Consumo alcohol/tabaco',
                q8: 'Lesiones congénitas',
                q9: 'Minusvalía o incapacidad'
            }
            return textos[key] || key
        },

        cerrarModalCuestionario() {
            this.mostrarModalCuestionario = false
            this.cuestionarioSeleccionado = null
            this.mostrarJson = false
        },

        imprimirCuestionario() {
            const contenido = document.querySelector('.modal-lg .modal-body')
            const ventana = window.open('', '_blank')
            ventana.document.write(`
                <html>
                    <head>
                        <title>Cuestionario de Salud</title>
                        <style>
                            body { font-family: Arial, sans-serif; padding: 20px; }
                            .resumen-header { margin-bottom: 20px; }
                            .pregunta-item { margin: 10px 0; padding: 8px; border-bottom: 1px solid #eee; }
                            .respuesta-si { background: #fce8e6; }
                            .respuesta-no { background: #e6f4ea; }
                            .badge-si { color: #d93025; font-weight: bold; }
                            .badge-no { color: #1e8e3e; }
                            @media print {
                                body { margin: 0; }
                                .no-print { display: none; }
                            }
                        </style>
                    </head>
                    <body>
                        ${contenido.innerHTML}
                        <div class="no-print" style="margin-top: 30px; text-align: center;">
                            <button onclick="window.print()">Imprimir</button>
                        </div>
                    </body>
                </html>
            `)
            ventana.document.close()
        },
        // En AreaPrivada.vue, añadir este método junto a los demás
        descargarCuestionarioPDF() {
            if (!this.cuestionarioSeleccionado) {
                alert('No hay datos del cuestionario para descargar')
                return
            }

            const data = this.cuestionarioSeleccionado

                // ✅ DEPURACIÓN: Ver qué datos llegan
            console.log('🔍 DATOS COMPLETOS DEL CUESTIONARIO:', data)
            console.log('🔍 RESPUESTAS:', data.respuestas)
            console.log('🔍 TIPO DE RESPUESTAS:', typeof data.respuestas)
            console.log('🔍 ¿ES ARRAY?', Array.isArray(data.respuestas))

            const doc = new jsPDF({
                orientation: 'portrait',
                unit: 'mm',
                format: 'a4',
                compress: true
            })

            // Obtener logos
            const asisaLogoImg = document.getElementById('logo-asisa-pdf')
            const getBase64Image = (img) => {
                if (!img || img.naturalWidth === 0) return null
                try {
                    const canvas = document.createElement("canvas")
                    canvas.width = img.naturalWidth
                    canvas.height = img.naturalHeight
                    const ctx = canvas.getContext("2d")
                    ctx.drawImage(img, 0, 0)
                    return canvas.toDataURL("image/jpeg", 0.6)
                } catch (e) {
                    console.error("Canvas conversion error:", e)
                    return null
                }
            }

            const asisaData = getBase64Image(asisaLogoImg)

            // ============================================
            // PÁGINA 1 - CUESTIONARIO DE SALUD
            // ============================================

            // ---- CABECERA ----
            if (asisaData) {
                doc.addImage(asisaData, 'JPEG', 15, 8, 40, 14)
            } else {
                doc.setTextColor(28, 74, 141)
                doc.setFontSize(18)
                doc.setFont('helvetica', 'bold')
                doc.text('asisa', 15, 18)
            }

            doc.setTextColor(0, 0, 0)
            doc.setFontSize(11)
            doc.setFont('helvetica', 'bold')
            doc.text('CUESTIONARIO DE SALUD', 105, 16, { align: 'center' })
            doc.setFontSize(9)
            doc.setFont('helvetica', 'normal')
            doc.text('ASISA Health Residents', 105, 23, { align: 'center' })

            doc.setDrawColor(28, 74, 141)
            doc.setLineWidth(0.3)
            doc.line(15, 28, 195, 28)

            // ---- DATOS PERSONALES ----
            let y = 35
            const lineHeight = 7

            doc.setFontSize(9)
            doc.setFont('helvetica', 'normal')

            const nombreCompleto = data.nombre_completo || 
                                (data.nombre && data.apellidos ? `${data.nombre} ${data.apellidos}` : '') ||
                                (data.titular || '')
            doc.text('Nombre y Apellidos:', 15, y)
            doc.text(nombreCompleto || '_________________________', 65, y)
            y += lineHeight

            const fechaNac = data.fecha_nacimiento || data.birthdate || ''
            doc.text('Fecha de nacimiento:', 15, y)
            doc.text(fechaNac || '_________________________', 65, y)
            y += lineHeight

            const documento = data.documento || data.identidad || ''
            doc.text('N.I.F./N.I.E.:', 15, y)
            doc.text(documento || '_________________________', 65, y)
            y += lineHeight

            const peso = data.peso || ''
            const estatura = data.estatura || ''
            doc.text('Peso (kg.):', 15, y)
            doc.text(peso || '___', 55, y)
            doc.text('Talla (cm.):', 75, y)
            doc.text(estatura || '___', 105, y)
            y += lineHeight

            doc.text('Sexo:', 15, y)
            const sexo = data.sexo || 'hombre'
            if (sexo === 'hombre') {
                doc.text('[ X ] Hombre', 55, y)
                doc.text('[   ] Mujer', 85, y)
            } else {
                doc.text('[   ] Hombre', 55, y)
                doc.text('[ X ] Mujer', 85, y)
            }
            y += lineHeight + 3

            // ---- NOTA IMPORTANTE ----
            doc.setFontSize(7.5)
            doc.setTextColor(80, 80, 80)
            doc.setFont('helvetica', 'italic')
            const nota = '(*) Salvo secuelas o complicaciones, no es preciso declarar las hospitalizaciones o intervenciones por los siguientes motivos: amigdalectomía, adenoidectomía, apendicectomía, cesárea, parto, ligadura de trompas, quistes sebáceos o lipomas, vasectomía, fimosis, orzuelos/chalazión o cirugía correctora agudeza visual.'
            const notaLines = doc.splitTextToSize(nota, 175)
            doc.text(notaLines, 15, y)
            y += (notaLines.length * 4) + 3
            doc.setTextColor(0, 0, 0)
            doc.setFont('helvetica', 'normal')
            doc.setFontSize(8.5)
            
            // ---- PREGUNTAS ----
            const preguntas = [
                // ✅ Preguntas principales (IDs 1, 2, 3, 4, 6, 7, 8, 9)
                { id: '1', text: '1. ¿Ha sido ingresado en algún centro sanitario en los últimos 10 años, o tiene previsto hacerlo? (*)' },
                { id: '2', text: '2. ¿Ha sido intervenido quirúrgicamente, o tiene previsto hacerlo? (*)' },
                { id: '3', text: '3. ¿Padece o ha padecido algún proceso tumoral o cáncer?' },
                { id: '4', text: '4. ¿Tiene o ha tenido algún síntoma, dolor o alteración de forma persistente, periódica o reiterada, o está bajo control o seguimiento médico por algún motivo?' },
                // ✅ Subpreguntas (IDs 5_1, 5_2, ..., 5_8)
                { id: '5_1', text: '5.1 Cardíaca, vascular, pulmonar o respiratoria (p. ej.: hipertensión, arritmias, insuficiencia cardiaca o circulatoria, varices, asma, enfisema, trombosis...). No es preciso reflejar catarros o gripes, salvo que hayan precisado hospitalización o generado secuelas.' },
                { id: '5_2', text: '5.2 Metabólica (del sistema endocrino) o del aparato digestivo (p. ej.: del hígado o páncreas, úlcera gastroduodenal, hernias, diabetes, tiroideas...).' },
                { id: '5_3', text: '5.3 Reumatológicas, óseas o musculares (p. ej.: artritis, artrosis, escoliosis, hernia discal, fibromialgia, lupus, esclerodermia, enfermedad muscular, secuelas de traumatismos, psoriasis...).' },
                { id: '5_4', text: '5.4 Del sistema nervioso, de los ojos o de los oídos (p. ej.: migrañas, epilepsia, Parkinson, parálisis, Alzheimer, glaucoma, degeneración macular, pérdida de visión, TDAH...). No es preciso reflejar miopía (con menos de 8 dioptrías en cada ojo), astigmatismo, hipermetropía y/o presbicia.' },
                { id: '5_5', text: '5.5 Hematológicas o de la coagulación (p. ej.: tromboembolismo, anemia, hemofilia, leucemia...).' },
                { id: '5_6', text: '5.6 Del Riñón, tracto urológico y genital, o ginecológicas (p. ej.: insuficiencia renal, alteraciones de la próstata, cólicos nefríticos, de transmisión sexual, ginecológicas -de mama, útero, ovarios...).' },
                { id: '5_7', text: '5.7 Psiquiátricas (p. ej.: anorexia, bulimia, depresión, ansiedad psicosis, esquizofrenia...).' },
                { id: '5_8', text: '5.8 Infecciosas (p. ej.: hepatitis, covid-19, tuberculosis, parasitosis, septicemia, enfermedades tropicales...).' },
                // ✅ Más preguntas principales
                { id: '6', text: '6. ¿Toma alguna medicación?' },
                { id: '7', text: '7. ¿Consume/ha consumido alcohol o drogas? ¿Fuma o ha fumado?' },
                { id: '8', text: '8. ¿Tiene lesiones o secuelas de una enfermedad, alteración congénita o hereditaria, malformaciones o accidente?' },
                { id: '9', text: '9. ¿Tiene reconocida o está en proceso de valoración de alguna minusvalía o incapacidad?' }
            ]

            const getRespuesta = (id) => {
                if (!data.respuestas) return 'NO'
                
                if (Array.isArray(data.respuestas)) {
                    // Buscar por id exacto o por id convertido a string
                    const found = data.respuestas.find(r => {
                        const rId = r.id ? r.id.toString() : ''
                        return rId === id || rId === id.toString()
                    })
                    if (found) {
                        const valor = found.value ? found.value.toLowerCase().trim() : ''
                        return (valor === 'si' || valor === 'sí') ? 'SI' : 'NO'
                    }
                    return 'NO'
                }
                return 'NO'
            }

            // ✅ Función para obtener la aclaración (ahora busca dentro de la respuesta)
            const getAclaracion = (id) => {
                if (!data.respuestas) return ''
                
                if (Array.isArray(data.respuestas)) {
                    const found = data.respuestas.find(r => {
                        const rId = r.id ? r.id.toString() : ''
                        return rId === id || rId === id.toString()
                    })
                    if (found && found.value && found.value.toLowerCase().trim() === 'si') {
                        return found.clarification || ''
                    }
                    return ''
                }
                return ''
            }

            preguntas.forEach((p, index) => {
                const respuesta = getRespuesta(p.id)
                const aclaracion = getAclaracion(p.id)

                // Guardar la posición Y antes de dibujar la pregunta
                const startY = y

                doc.setFont('helvetica', 'normal')
                doc.setFontSize(8.5)
                const lines = doc.splitTextToSize(p.text, 145)
                doc.text(lines, 15, y)
                y += (lines.length * 4.5)

                // Respuesta alineada con la PRIMERA línea de la pregunta
                const siChecked = respuesta === 'SI' ? '[X]' : '[ ]'
                const noChecked = respuesta === 'NO' ? '[X]' : '[ ]'
                doc.text(`${siChecked} SI    ${noChecked} NO`, 160, startY)

                // ✅ Mostrar aclaración si existe
                if (respuesta === 'SI' && aclaracion) {
                    y += 3
                    doc.setFont('helvetica', 'italic')
                    doc.setFontSize(7.5)
                    const aclLines = doc.splitTextToSize(`Aclaración: ${aclaracion}`, 160)
                    doc.text(aclLines, 20, y)
                    y += (aclLines.length * 4) + 1
                    doc.setFont('helvetica', 'normal')
                }

                y += 3

                // Línea de puntos entre preguntas (excepto después de la última)
                if (index < preguntas.length - 1) {
                    doc.setDrawColor(200, 200, 200)
                    doc.setLineWidth(0.2)
                    doc.setLineDashPattern([1, 2])
                    doc.line(15, y, 195, y)
                    doc.setLineDashPattern([])
                    y += 3
                }

                if (y > 265) {
                    doc.addPage()
                    y = 20
                }
            })

            y += 8;

            doc.setFontSize(8.5);
            doc.setFont('helvetica', 'normal');
            doc.setTextColor(0, 0, 0);

            const textFaltante = 'ASISA elude la asistencia derivada de patologías relacionadas con procesos anteriores a la contratación de la póliza o presentes en el momento de dicha contratación, conocidos y no declarados, conforme al presente cuestionario, así como de sus secuelas, brotes evolutivos y complicaciones. El abajo firmante autoriza expresamente a la Entidad ASISA, en relación con el contenido del presente cuestionario, a que realice los actos y gestiones oportunos para la comprobación de la trascendencia, existencia, evolución o desaparición de las enfermedades o lesiones a las que haya que prestar su asistencia, así como para poder conocer los posibles antecedentes o consecuencias de las mismas y tratamientos seguidos en cada caso a través de esta Entidad. De acuerdo con el artículo 10 de la Ley de Contrato de Seguro, en caso de reserva o inexactitud al cumplimentar la presente declaración, el asegurado perderá el derecho a la prestación garantizada, reservándose ASISA la facultad de rescindir automáticamente la póliza. A los efectos señalados, el firmante declara no haber desfigurado la verdad, ni ocultado la existencia de enfermedad o defecto alguno.';

            const textFaltanteLines = doc.splitTextToSize(textFaltante, 175);
            doc.text(textFaltanteLines, 15, y);
            y += (textFaltanteLines.length * 4.5) + 5;

            // 🔹 TEXTO DE PROTECCIÓN DE DATOS
            doc.setFontSize(8.5);
            doc.setFont('helvetica', 'bold');
            doc.setTextColor(0, 0, 0);
            doc.text('Información básica sobre protección de datos.', 15, y);
            y += 6;

            doc.setFont('helvetica', 'normal');
            doc.setFontSize(8);
            const textProteccion = 'Mediante su firma, el Tomador del Seguro declara haber recabado y obtenido el consentimiento expreso de cada uno de los asegurados/miembros del grupo familiar, con la finalidad de incorporar al presente cuestionario todos los datos de salud relativos a los mismos.';
            const textProteccionLines = doc.splitTextToSize(textProteccion, 175);
            doc.text(textProteccionLines, 15, y);
            y += (textProteccionLines.length * 4.5) + 8;

            // Después de la nota legal y antes de la firma
            // ============================================
            // NOMBRE Y FIRMA D./DÑA. CON IMAGEN DE LA FIRMA
            // ============================================

            if (y > 260) {
                doc.addPage();
                y = 20;
            }

            doc.setFontSize(9);
            doc.setFont('helvetica', 'bold');
            doc.text('Nombre y firma D./Dña.:', 15, y);
            y += 7;

            doc.setFont('helvetica', 'normal');
            doc.text('[ ] En nombre propio', 15, y);
            y += 6;
            doc.text('[ ] Como contratante de la póliza o familiar mayor de edad', 15, y);

            // 🔹 AÑADIR LA FIRMA DEL USUARIO
            y += 12;

            // Obtener la firma del usuario (desde el objeto data)
            const firmaUsuario = data.firma_usuario || null;
            console.log("aaaaa", firmaUsuario)

            if (firmaUsuario) {
                try {
                    // Si la firma tiene prefijo data:image, usarla directamente
                    let firmaSrc = firmaUsuario;
                    if (firmaSrc && !firmaSrc.startsWith('data:image')) {
                        firmaSrc = 'data:image/png;base64,' + firmaSrc;
                    }
                    
                    // Añadir la firma al PDF (como imagen)
                    doc.addImage(firmaSrc, 'PNG', 25, y, 60, 25);
                    y += 30;
                } catch (e) {
                    console.warn('No se pudo añadir la firma del usuario:', e);
                    // Si falla, mostrar la línea de firma
                    doc.setFontSize(7);
                    doc.setFont('helvetica', 'italic');
                    doc.setTextColor(150, 150, 150);
                    doc.text('Firma del solicitante', 25, y);
                    doc.setTextColor(0, 0, 0);
                }
            }

            // Línea de firma (por si no hay imagen o como respaldo)
            y += 10;
            doc.setDrawColor(150, 150, 150);
            doc.setLineWidth(0.3);
            doc.line(25, y, 120, y);
            y += 4;
            doc.setFontSize(7);
            doc.setFont('helvetica', 'italic');
            doc.setTextColor(150, 150, 150);
            doc.text('Firma del solicitante', 25, y);
            doc.setTextColor(0, 0, 0);

            // ============================================
            // PÁGINA 2 - INFORMACIÓN DE PROTECCIÓN DE DATOS
            // ============================================
            doc.addPage()
            let y2 = 20

            doc.setFontSize(10)
            doc.setFont('helvetica', 'bold')
            doc.text('INFORMACIÓN BÁSICA SOBRE PROTECCIÓN DE DATOS', 15, y2)
            y2 += 6
            doc.setFontSize(8.5)
            doc.setFont('helvetica', 'normal')

            const tableData = [
                ['Responsable del tratamiento', 'ASISA, ASISTENCIA SANITARIA INTERPROVINCIAL DE SEGUROS S.A.U.'],
                ['Finalidad', 'El estudio de la viabilidad para la contratación de una póliza de seguro.'],
                ['Legitimación', 'La base legal para el tratamiento de sus datos se encuentra en la aplicación de medidas precontractuales entre el tomador y ASISA.'],
                ['Destinatarios', '• Personas, organismos e instituciones que pudieran acreditar un interés legítimo u obligación legal.\n• Médicos, centros médicos, hospitales y otras instituciones o personas, identificadas como prestadores de servicios sanitarios en la Lista de Facultativos elaborada por ASISA o en su sitio web www.asisa.es.'],
                ['Derechos', 'Puede ejercitar los derechos de acceso, rectificación o supresión, limitación del tratamiento, oposición, portabilidad de los datos o a no ser objeto de una decisión basada únicamente en el tratamiento automatizado.'],
                ['Información adicional', 'Puede dirigirse al Delegado de Protección de Datos (DPO) del Grupo ASISA (DPO@grupoasisa.com), así como consultar la información adicional y detallada sobre Protección de Datos en la web de ASISA: www.asisa.es']
            ]

            tableData.forEach(([label, value]) => {
                doc.setFont('helvetica', 'bold')
                doc.setFontSize(8)
                doc.text(label + ':', 15, y2)
                doc.setFont('helvetica', 'normal')

                const valueLines = doc.splitTextToSize(value, 120)
                doc.text(valueLines, 80, y2)
                y2 += (valueLines.length * 4.5) + 3
            })

            y2 += 10
            doc.setFont('helvetica', 'bold')
            doc.setFontSize(9)
            doc.text('Espacio reservado para asesoría médica', 15, y2)
            y2 += 8
            doc.setFont('helvetica', 'normal')
            doc.setFontSize(8.5)
            
            doc.text('Médico valorador:', 15, y2)
            doc.text('_________________________', 60, y2)
            y2 += 7
            
            doc.text('Adm. Producción:', 15, y2)
            doc.text('_________________________', 60, y2)
            y2 += 8
            
            doc.setFont('helvetica', 'bold')
            doc.text('Informes médicos que debe aportar para la contratación:', 15, y2)
            y2 += 6
            doc.setFont('helvetica', 'normal')
            doc.text('________________________________________________________', 15, y2)
            y2 += 7
            doc.text('________________________________________________________', 15, y2)
            y2 += 7
            doc.text('________________________________________________________', 15, y2)
            y2 += 8
            
            doc.setFont('helvetica', 'bold')
            doc.text('Observaciones:', 15, y2)
            y2 += 6
            doc.setFont('helvetica', 'normal')
            doc.text('________________________________________________________', 15, y2)
            y2 += 7
            doc.text('________________________________________________________', 15, y2)
            y2 += 7
            doc.text('________________________________________________________', 15, y2)
            y2 += 7
            doc.text('________________________________________________________', 15, y2)

            doc.setFontSize(7)
            doc.setTextColor(150, 150, 150)
            doc.text('Documento generado automáticamente desde el Área Privada de ASISA Health Visa', 105, 285, { align: 'center' })

            doc.save(`Cuestionario_Salud_${data.documento || 'cliente'}.pdf`)
        }
    }
}
</script>

<style scoped>
.dashboard-container {
    display: flex;
    min-height: 100vh;
    background: #f5f7fa;
    font-family: 'Open Sans', sans-serif;
}

/* ========== MAIN CONTENT ========== */
.main-content {
    margin-left: 260px;
    flex-grow: 1;
    padding: 40px;
}

/* ========== HEADER ========== */
.header-dashboard {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
}

.header-dashboard h1 {
    font-size: 1.8rem;
    color: #202124;
    margin-bottom: 5px;
}

.header-dashboard p {
    color: #5f6368;
}

.user-profile {
    display: flex;
    align-items: center;
    gap: 12px;
}

.avatar-circle {
    width: 40px;
    height: 40px;
    background: #1C4A8D;
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    text-transform: uppercase;
}

.user-name {
    font-weight: 600;
    font-size: 0.9rem;
    margin: 0;
}

.user-role {
    font-size: 0.75rem;
    color: #5f6368;
    margin: 0;
}

/* ========== STATS CARDS ========== */
.stats-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 25px;
    margin-bottom: 40px;
}

.stat-card {
    background: white;
    padding: 25px;
    border-radius: 12px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.05);
    display: flex;
    align-items: center;
    gap: 20px;
}

.stat-icon {
    width: 50px;
    height: 50px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.5rem;
}

.stat-icon.blue { background: #e8f0fe; color: #1C4A8D; }
.stat-icon.green { background: #e6f4ea; color: #1e8e3e; }
.stat-icon.orange { background: #fff4e5; color: #ef6c00; }

.stat-info h4 {
    font-size: 0.9rem;
    color: #5f6368;
    margin-bottom: 5px;
    font-weight: 500;
}

.stat-value {
    font-size: 1.8rem;
    font-weight: 700;
    color: #202124;
}

/* ========== TABLE ========== */
.table-container {
    background: white;
    border-radius: 12px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.05);
    overflow-x: auto;
}

.table-header {
    padding: 20px 25px;
    border-bottom: 1px solid #f1f3f4;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.table-header h3 {
    font-size: 1.1rem;
    color: #202124;
    margin: 0;
}

.polizas-table {
    width: 100%;
    border-collapse: collapse;
    min-width: 600px;
}

.polizas-table th {
    text-align: left;
    background: #f8f9fa;
    padding: 15px 25px;
    color: #5f6368;
    font-weight: 600;
    font-size: 0.85rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.polizas-table td {
    padding: 18px 25px;
    border-bottom: 1px solid #f1f3f4;
    color: #3c4043;
    font-size: 0.95rem;
}

.status-badge {
    padding: 6px 12px;
    border-radius: 20px;
    font-size: 0.8rem;
    font-weight: 600;
    display: inline-block;
}

.status-badge.emitida {
    background: #e6f4ea;
    color: #1e8e3e;
}

.status-badge.revision {
    background: #fff4e5;
    color: #ef6c00;
}

.btn-table {
    padding: 6px 12px;
    border: 1px solid #dadce0;
    border-radius: 6px;
    background: white;
    color: #3c4043;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 0.85rem;
    cursor: pointer;
    transition: all 0.2s;
    text-decoration: none;
}

.btn-table:hover {
    background: #f8f9fa;
    border-color: #bdc1c6;
}

/* ========== STATES ========== */
.loading-state,
.empty-state {
    text-align: center;
    padding: 60px 20px;
    color: #5f6368;
}

.empty-state .btn-primary {
    display: inline-block;
    margin-top: 15px;
    background: #1C4A8D;
    color: white;
    padding: 10px 25px;
    border-radius: 30px;
    text-decoration: none;
}

 /* Toggle Button styling */
        .btn-toggle-vto {
            padding: 6px 12px;
            border: 1px solid #dadce0;
            border-radius: 6px;
            background: #f8f9fa;
            color: #5f6368;
            display: inline-flex;
            align-items: center;
            gap: 6px;
            font-size: 0.85rem;
            cursor: pointer;
            transition: all 0.2s;
            margin-left: 8px;
        }

        .btn-toggle-vto.active {
            background: #fce8e6;
            color: #d93025;
            border-color: #f5c2c7;
        }

        .btn-toggle-vto ion-icon {
            font-size: 1.1rem;
        }

/* ========== RESPONSIVE ========== */
@media (max-width: 768px) {
    .sidebar {
        width: 80px;
        padding: 20px 10px;
    }
    .sidebar-logo span,
    .sidebar-nav span {
        display: none;
    }
    .sidebar-logo {
        justify-content: center;
    }
    .main-content {
        margin-left: 80px;
        padding: 20px;
    }
    .stats-grid {
        grid-template-columns: 1fr;
    }
}
/* ========== BOTÓN FILTRAR ========== */
    .btn-filter {
        padding: 8px 16px;
        background: white;
        border: 1px solid #dadce0;
        border-radius: 8px;
        color: #5f6368;
        display: inline-flex;
        align-items: center;
        gap: 8px;
        font-size: 0.85rem;
        cursor: pointer;
        transition: all 0.2s;
    }

    .btn-filter:hover {
        background: #f8f9fa;
        border-color: #bdc1c6;
    }

    .filter-badge {
        color: #1C4A8D;
        font-size: 0.7rem;
    }

    /* ========== EXPORTAR A EXCELl ========== */
    .header-actions {
        display: flex;
        gap: 10px;
    }

    .btn-export {
        padding: 8px 16px;
        background: #28a745;
        color: white;
        border: none;
        border-radius: 8px;
        display: inline-flex;
        align-items: center;
        gap: 8px;
        font-size: 0.85rem;
        cursor: pointer;
        transition: background 0.2s;
    }

    .btn-export:hover {
        background: #1e7e34;
    }

    .btn-export:disabled {
        opacity: 0.7;
        cursor: not-allowed;
    }

    /* ========== MODAL ========== */
    .modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.5);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1100;
    }

    .modal-content {
        background: white;
        border-radius: 16px;
        width: 90%;
        max-width: 500px;
        max-height: 85vh;
        display: flex;
        flex-direction: column;
        overflow: hidden;  /* ← Importante: el overflow se maneja internamente */
    }

    /* ✅ HEADER FIJO */
    .modal-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px 25px;
        border-bottom: 1px solid #e1e4e8;
        background: white;
        flex-shrink: 0;  /* ← No se encoge */
    }

    .modal-header h3 {
        margin: 0;
        color: #202124;
    }

    .modal-close {
        background: none;
        border: none;
        font-size: 24px;
        cursor: pointer;
        color: #5f6368;
    }

    /* ✅ BODY SCROLLABLE */
    .modal-body {
        padding: 25px;
        overflow-y: auto;  /* ← Scroll solo aquí */
        flex-grow: 1;      /* ← Ocupa el espacio disponible */
    }

    /* ✅ FOOTER FIJO */
    .modal-footer {
        padding: 20px 25px;
        border-top: 1px solid #e1e4e8;
        display: flex;
        justify-content: flex-end;
        gap: 12px;
        background: white;
        flex-shrink: 0;  /* ← No se encoge */
    }

    .filter-group {
        margin-bottom: 20px;
    }

    .filter-group label {
        display: block;
        margin-bottom: 8px;
        font-weight: 600;
        font-size: 0.9rem;
        color: #3c4043;
    }

    .filter-group select,
    .filter-group input {
        width: 100%;
        padding: 10px 12px;
        border: 1px solid #dadce0;
        border-radius: 8px;
        font-size: 0.9rem;
    }

    .filter-group select:focus,
    .filter-group input:focus {
        outline: none;
        border-color: #1C4A8D;
    }

    .btn-clear {
        padding: 10px 20px;
        background: white;
        border: 1px solid #dadce0;
        border-radius: 8px;
        cursor: pointer;
    }

    .btn-apply {
        padding: 10px 20px;
        background: #1C4A8D;
        color: white;
        border: none;
        border-radius: 8px;
        cursor: pointer;
    }

    .btn-apply:hover {
        background: #153a70;
    }

    /* ========== ESTILOS MODAL RESPUESTAS =========*/
        /* Modal grande para cuestionario */
    .modal-lg {
        max-width: 800px;
        width: 90%;
    }

    .cuestionario-resumen {
        padding: 10px;
    }

    .resumen-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px;
        background: #f8f9fa;
        border-radius: 8px;
        margin-bottom: 20px;
    }

    .badge-warning {
        background: #fff4e5;
        color: #ef6c00;
        padding: 5px 12px;
        border-radius: 20px;
    }

    .badge-success {
        background: #e6f4ea;
        color: #1e8e3e;
        padding: 5px 12px;
        border-radius: 20px;
    }

    .cuestionario-datos, .cuestionario-preguntas, .cuestionario-aclaraciones {
        margin-bottom: 25px;
    }

    .cuestionario-datos h4,
    .cuestionario-preguntas h4,
    .cuestionario-aclaraciones h4 {
        color: #1C4A8D;
        margin-bottom: 12px;
        padding-bottom: 8px;
        border-bottom: 2px solid #e1e4e8;
    }

    .datos-grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 15px;
        background: #f8f9fa;
        padding: 15px;
        border-radius: 8px;
    }

    .preguntas-lista {
        max-height: 400px;
        overflow-y: auto;
        border: 1px solid #e1e4e8;
        border-radius: 8px;
    }

    .pregunta-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 12px 15px;
        border-bottom: 1px solid #e1e4e8;
    }

    .pregunta-item:last-child {
        border-bottom: none;
    }

    .pregunta-text {
        flex: 1;
        font-size: 0.9rem;
    }

    .pregunta-num {
        font-weight: 700;
        color: #1C4A8D;
        margin-right: 8px;
    }

    .respuesta-badge {
        padding: 4px 12px;
        border-radius: 20px;
        font-weight: 600;
        font-size: 0.8rem;
    }

    .badge-si {
        background: #fce8e6;
        color: #d93025;
    }

    .badge-no {
        background: #e6f4ea;
        color: #1e8e3e;
    }

    .pregunta-item.respuesta-si {
        background: #fef2f0;
    }

    .pregunta-item.respuesta-no {
        background: #f0faf0;
    }

    .aclaraciones-content {
        background: #f8f9fa;
        padding: 15px;
        border-radius: 8px;
    }

    .aclaracion-item {
        margin-bottom: 15px;
        padding-bottom: 10px;
        border-bottom: 1px solid #e1e4e8;
    }

    .aclaracion-item:last-child {
        border-bottom: none;
        margin-bottom: 0;
    }

    .aclaracion-item p {
        margin: 8px 0 0 0;
        padding-left: 15px;
        color: #5f6368;
        font-style: italic;
    }

    .cuestionario-json {
        margin-top: 20px;
        border-top: 1px solid #e1e4e8;
        padding-top: 15px;
    }

    .json-header {
        cursor: pointer;
        color: #1C4A8D;
        display: flex;
        align-items: center;
        gap: 5px;
        font-size: 0.85rem;
        user-select: none;
    }

    .json-content {
        background: #1e1e1e;
        color: #d4d4d4;
        padding: 15px;
        border-radius: 8px;
        font-size: 0.75rem;
        overflow-x: auto;
        margin-top: 10px;
    }
    /* ========= Grupo de botones de acción =========*/
    .actions {
        white-space: nowrap;
    }

    .btn-group {
        display: inline-flex;
        gap: 6px;
        align-items: center;
    }

    .btn-icon {
        background: white;
        border: 1px solid #dadce0;
        border-radius: 6px;
        padding: 6px 10px;
        cursor: pointer;
        transition: all 0.2s;
        display: inline-flex;
        align-items: center;
        gap: 4px;
        font-size: 0.75rem;
        color: #3c4043;
    }

    .btn-icon ion-icon {
        font-size: 1rem;
    }

    .btn-text {
        font-size: 0.7rem;
        font-weight: 500;
    }

    .btn-icon:hover {
        background: #f8f9fa;
        border-color: #bdc1c6;
    }

    .btn-icon.active {
        background: #fce8e6;
        color: #d93025;
        border-color: #f5c2c7;
    }

    .btn-icon.active:hover {
        background: #fce8e6;
    }

    .btn-icon:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    /* Responsive para móvil */
    @media (max-width: 768px) {
        .btn-icon {
            padding: 6px 8px;
        }
        .btn-text {
            display: none;
        }
        .btn-icon ion-icon {
            font-size: 1.1rem;
        }
    }
</style>